import Api from "./Api";
import axios from "axios";

async function doBillPayment(token, params,cancelToken) {

    const headers = {
        "Authorization": `Bearer ${token}`
    }
    const response = await Api.post('/api/v1/Fronts/TosanBillPayment/DoPay',  params,{headers,cancelToken,});

    return response;
}

export default doBillPayment;